import $ from 'jquery';

// Import FontAwesome
import { library, dom }
from '@fortawesome/fontawesome-svg-core';
import {
  faBars,
  faPhoneAlt,
  faEnvelope,
  faAngleLeft,
  faAngleRight,
  faArrowRight,
  faArrowLeft,
  faMapMarkerAlt
}
from '@fortawesome/free-solid-svg-icons';


import {  }
from '@fortawesome/free-brands-svg-icons';

$(document).ready(function () {
  library.add(
  );
  library.add(
    faBars,
    faPhoneAlt,
    faEnvelope,
    faAngleLeft,
    faAngleRight,
    faArrowRight,
    faArrowLeft,
    faMapMarkerAlt
  );
  dom.watch();
});
